import { FunctionComponent, SVGProps } from 'react'

export const IconGem: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const paint0 = `${id}-paint0`

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M8.0013 4.5H18.0013L21.3346 9.5L13.0013 20.3333L4.66797 9.5L8.0013 4.5Z"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M8.0013 4.5H18.0013L21.3346 9.5L13.0013 20.3333L4.66797 9.5L8.0013 4.5Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M13 20.3333L16.3333 9.5L13.8333 4.5"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0013 20.3333L9.66797 9.5L12.168 4.5"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66797 9.5H21.3346"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id={filter0}
          x="0.0546875"
          y="0"
          width="25.8945"
          height="25.1543"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2355_36447"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2355_36447"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="13.0013"
          y1="4.5"
          x2="13.0013"
          y2="20.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
